import { defineMessage } from 'react-intl';

import { useConfigContext } from 'contexts/config';
import { ConfigQuery } from 'contexts/config/types';
import { useIntlContext } from 'contexts/intl';

const defaultDisplayName = defineMessage({
  id: 'so5Competitions.default',
  defaultMessage: 'All',
});

export const useSo5Competitions = () => {
  const { formatMessage } = useIntlContext();
  const {
    so5: { so5Competitions },
  } = useConfigContext();
  const scoutableSo5Competitions = so5Competitions.filter(
    so5Competition => so5Competition.scoutable
  );

  const DEFAULT: ConfigQuery['so5']['so5Competitions'][number] = {
    __typename: 'So5Competition',
    slug: 'DEFAULT',
    displayName: formatMessage(defaultDisplayName),
    logoUrl: 'DEFAULT',
    iconUrl: 'DEFAULT',
    backgroundUrl: '',
    algoliaFilters: '',
    scoutable: true,
    competitions: [],
  };

  return {
    so5Competitions,
    scoutableSo5Competitions,
    filterableSo5Competitions: so5Competitions.filter(
      so5Competition => !!so5Competition.algoliaFilters
    ),
    defaultSo5Competition: DEFAULT,
  };
};
